/**
 * @param data {Data}
 */
module.exports = function thenSetGlobalAppStartedFlag(data) {
  data.window.APP_STARTED = true;
};
